import React, { useState, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import Cookies from 'universal-cookie';
import cx from 'classnames';

import { Modal } from './../Modal';
import { ModalClose } from './../ModalClose';

import ModalPartnerSignup from './../ModalPartnerSignup';
import ModalAffiliateContactForm from './../ModalAffiliateContactForm';

import Form from './form';
import auth0 from 'auth0-js';

import Button, { ButtonStyles } from '../../Button/Button';
import {
  logBrazeAccountRegistration,
  queueBrazeEmailSubscriptionAfterSignup,
  setBrazeAuthMethod,
} from '../../../command/braze';
import {
  trackNewsletterConsentRecorded,
  NEWSLETTER_SOURCES,
} from '../../../utils/posthogTracking';

const webAuth = new auth0.WebAuth({
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  scope: 'openid profile email',
  redirectUri: window.location.origin,
  responseType: 'token',
});

const cookies = new Cookies();

// Lets external callers (GTM, etc.) open the modal.
// Same window CustomEvent bridge used for 'addtowishlist' in WishlistBridge.js
const OPEN_SIGNUP_MODAL_EVENT = 'opensignupmodal';

// Lets a plain link (e.g. a Braze in-app message button action, no custom
// HTML/JS needed) open the modal by landing on ?openSignup=1.
const OPEN_SIGNUP_QUERY_PARAM = 'openSignup';

window.SignupModal = {
  open: () => window.dispatchEvent(new CustomEvent(OPEN_SIGNUP_MODAL_EVENT)),
};

const ModalCustomerSignup = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState(false);

  useEffect(() => {
    const openModal = () => {
      setIsModalOpen(true);
      setAlertMessage(false);
    };

    window.addEventListener(OPEN_SIGNUP_MODAL_EVENT, openModal);

    if (
      new URLSearchParams(window.location.search).has(OPEN_SIGNUP_QUERY_PARAM)
    ) {
      openModal();
      const url = new URL(window.location.href);
      url.searchParams.delete(OPEN_SIGNUP_QUERY_PARAM);
      window.history.replaceState({}, document.title, url.toString());
    }

    return () => window.removeEventListener(OPEN_SIGNUP_MODAL_EVENT, openModal);
  }, []);

  const onSubmit = ({ email, password, privacy, newsletter, ...values }) => {
    setIsLoading(true);
    cookies.set('target_url', window.location.pathname, { path: '/' });

    webAuth.signupAndAuthorize(
      {
        connection: 'DB-wpdbfreedomeit',
        email: email,
        password: password,
        user_metadata: {
          ...values,
          privacy: 'true',
          newsletter: newsletter ? 'true' : 'false',
        },
      },
      function (err, authResult) {
        if (err) {
          if (err.statusCode === 400 && err.code === 'user_exists') {
            setAlertMessage(true);
          }

          // return console.log(err);
        }
        // TODO: add cookie expiration, the code below seems not working
        // expires: new Date(Date.now() + (authResult.expiresIn * 1000)), httpOnly: true,
        cookies.set('auth0_token', authResult.accessToken, { path: '/' });

        // PostHog sends the events in its queue before the reload.
        trackNewsletterConsentRecorded(
          !!newsletter,
          NEWSLETTER_SOURCES.SIGNUP_MODAL
        );

        // Apply this choice after reload, once Braze has identified the account.
        queueBrazeEmailSubscriptionAfterSignup(email, newsletter);
        logBrazeAccountRegistration('email_password', 'menu');
        setBrazeAuthMethod('email_password');

        location.reload();

        setIsLoading(false);
        setIsSuccess(true);
      }
    );
  };

  const auth0Google = () => {
    cookies.set('target_url', window.location.pathname, { path: '/' });
    // Braze: will be identified on next page load via auth.js;
    // auth_method will be set from user data returned by core API
    webAuth.authorize({
      connection: 'google-oauth2',
    });
  };

  const auth0Facebook = () => {
    cookies.set('target_url', window.location.pathname, { path: '/' });
    webAuth.authorize({
      connection: 'facebook',
    });
  };

  const auth0Apple = () => {
    cookies.set('target_url', window.location.pathname, { path: '/' });
    webAuth.authorize({
      connection: 'apple',
    });
  };

  const modal = (
    <Modal
      onClickOverlay={() => {
        setIsModalOpen(false);
        setAlertMessage(false);
      }}
      isOpen={isModalOpen}
      shouldScroll={false}
    >
      <div className="modal-partner-signup" style={{ width: 375 }}>
        <ModalClose
          onClick={() => {
            setIsModalOpen(false);
            setAlertMessage(false);
          }}
        />
        <Form
          onSubmit={onSubmit}
          auth0Google={auth0Google}
          auth0Facebook={auth0Facebook}
          auth0Apple={auth0Apple}
          alertMessage={alertMessage}
        />
      </div>
    </Modal>
  );
  if (window.location.pathname == '/diventa-partner-freedome/') {
    return (
      <ModalPartnerSignup
        layout={'navbar'}
        prefixesAreVisible={props.prefixesAreVisible}
      />
    );
  }

  if (window.location.pathname == '/diventa-affiliato-freedome/') {
    return (
      <ModalAffiliateContactForm
        layout={'navbar'}
        prefixesAreVisible={props.prefixesAreVisible}
      />
    );
  }

  switch (props.layout) {
    case 'navbar':
      return (
        <React.Fragment>
          {modal}
          <li
            className={cx('navbar__menu__item', 'registration')}
            onClick={(e) => {
              setIsModalOpen(true);
            }}
          >
            <span>{app_main_wpml.signup}</span>
          </li>
        </React.Fragment>
      );

    case 'beta-navbar':
      return (
        <React.Fragment>
          {modal}
          <div
            className="dropdown__navbar__item"
            onClick={() => setIsModalOpen(true)}
          >
            {app_main_wpml.signup}
          </div>
        </React.Fragment>
      );

    default:
      return (
        <>
          {modal}
          <Button
            label={app_main_wpml.signup}
            style={ButtonStyles.ghost}
            onClick={() => setIsModalOpen(true)}
          ></Button>
        </>
      );
  }
};

ModalCustomerSignup.defaultProps = {
  layout: null,
  className: '',
};

ModalCustomerSignup.propTypes = {
  layout: PropTypes.string,
  className: PropTypes.string,
  prefixesAreVisible: PropTypes.string,
};

export { ModalCustomerSignup };
